/**
 * @description UI Store Module
 * @author Fahid Mohammad
 */

const VueCookie = require('vue-cookie') // using require to avoid SSR rejection

export default {
    namespaced: true,
    state: {
        isDashboard:false,
        isEmployees:false,
        isPatients:false,
        isDoctor:false,
        isAppointments:false,
        isSchedule:false,
        isPharmacy:false,
        isParamedical:false,
        isAccounts:false,
        isRoleManager:false,
        isMaster:false,
        isSettings:false,
        isSubmenu:false,
        isService:false,
        isChangepwd:false,
        isReviews:false,
        isProfile:false,
        isPackages:false,
    },
    mutations:{
        updateIs: (state, {which} ) => {
            //  Reset Is's
            switch(which){
                case 'dashboard': state.isDashboard = true; break;
                case 'employees': state.isEmployees = true; break;
                case 'patients': state.isPatients = true; break;
                case 'doctor': state.isDoctor = true; break;
                case 'appointments': state.isAppointments = true; break;
                case 'schedule': state.isSchedule = true; break;
                case 'pharmacy': state.isPharmacy = true; break;
                case 'paramedical': state.isParamedical = true; break;
                case 'accounts': state.isAccounts = true; break;
                case 'rolemanager': state.isRoleManager = true; break;
                case 'services': state.isService = true; break;
                case 'master': state.isMaster = true; break;
                case 'settings': state.isSettings = true; break;
                case 'submenu': state.isSubmenu = true; break;
                case 'changepassword':state.isChangepwd=true;break;
                case 'reviews': state.isReviews = true; break;
                case 'profile': state.isProfile = true; break;
                case 'Packages':state.isPackages=true;break;
            }
        },
        resetIs: (state) => {
            state.isDashboard = false;
            state.isEmployees = false;
            state.isPatients = false;
            state.isDoctor = false;
            state.isAppointments = false;
            state.isSchedule = false;
            state.isPharmacy = false;
            state.isParamedical = false;
            state.isAccounts = false;
            state.isRoleManager = false;
            state.isService = false;
            state.isMaster = false;
            state.isSettings = false;
            state.isSubmenu = false;
            state.isChangepwd=false;
            state.isReviews = false;
            state.isProfile=false;
            state.isPackages = false;
        },
    },
    actions:{
        UPDATE_IS({ commit }, which) {
            commit('updateIs', { which })
        },
        RESET_IS({ commit }) {
            commit('resetIs')
        },
    },
    getters:{
        isDashboard: state => { return state.isDashboard },
        isEmployees: state => { return state.isEmployees },
        isPatients: state => { return state.isPatients },
        isDoctor: state => { return state.isDoctor },
        isAppointments: state => { return state.isAppointments },
        isSchedule: state => { return state.isSchedule },
        isPharmacy: state => { return state.isPharmacy },
        isParamedical: state => { return state.isParamedical },
        isAccounts: state => { return state.isAccounts },
        isRoleManager: state => { return state.isRoleManager },
        isService: state => { return state.isService },
        isMaster: state => { return state.isMaster },
        isSettings: state => { return state.isSettings },
        isSubmenu: state => { return state.isSubmenu },
        isChangepwd:state => { return state.isChangepwd },
        isReviews: state => { return state.isReviews },
        isProfile:state=> { return state.isProfile },
        isPackages:state => {return state.isPackages}
    }
}
    


// WEBPACK FOOTER //
// ./src/store/modules/ui.js